export enum HealthCheckerServiceActions {
  ALL = '*',
  Alerts = 'alerts',
  Games = 'games',
}
